import { hash } from '@ember/helper';
import Component from '@glimmer/component';
import type { ComponentLike } from '@glint/template';
import { gt } from 'ember-truth-helpers';

import UiWellItem, { type UiWellItemSignature } from './well/item';
import UiWellSection, { type UiWellSectionSignature } from './well/section';

interface UiWellSignature<T> {
  Args: {
    /**
     * Array to yield in <:items>. Each item will be pre-wrapped in a
     * WellItem. If items is empty, <:empty> will be rendered.
     */
    items?: T[];
  };
  Blocks: {
    default?: [{ Item: ComponentLike<UiWellItemSignature>; Section: ComponentLike<UiWellSectionSignature<T>> }];
    empty?: [];
    items?: [T];
  };
  Element: HTMLDivElement;
}

export default class UiWell<T> extends Component<UiWellSignature<T>> {
  <template>
    <div class="ui__well" ...attributes>
      {{#if (has-block "items")}}
        {{#if (gt @items.length 0)}}
          {{#each @items as |item|}}
            <UiWellItem>
              {{yield item to="items"}}
            </UiWellItem>
          {{/each}}
        {{else}}
          <UiWellItem>
            {{yield to="empty"}}
          </UiWellItem>
        {{/if}}
      {{else}}
        {{yield (hash Item=(component UiWellItem) Section=(component UiWellSection))}}
      {{/if}}
    </div>
  </template>
}
